import firebase from "firebase/app";
import "firebase/analytics"
import "firebase/remote-config";

const config = {
  apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY}`,
  authDomain: `${process.env.REACT_APP_FIREBASE_AUTH_DOMAIN}`,
  projectId: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}`,
  storageBucket: `${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}`,
  messagingSenderId: `${process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID}`,
  appId: `${process.env.REACT_APP_FIREBASE_APP_ID}`,
  measurementId: `${process.env.REACT_APP_FIREBASE_MEASUREMENT_ID}`,
};
const fb = firebase.initializeApp(config);
fb.remoteConfig().defaultConfig = {
  wheel_button: "Çevir",
  wheel_description: "Fenerin her maçı bize 10 GB fırsatı! 💛💙",
  wheel_error_description: "Beklenmeyen bir hata oluştu.",
  wheel_error_go_back: "Fenerin Maçı Var",
  wheel_error_title: "Sahaya yabancı madde girdi!",
  wheel_error_try_again: "Tekrar dene",
  wheel_header: "HEDİYE ÇARKI",
  wheel_link_exp_button: "Fenerin Maçı Var",
  wheel_link_exp_description: "Carki cevirmek icin hemen kanala geri don ve yeni linke tikla.",
  wheel_link_exp_title: "Çark çevirme hakkın Fenerbahçe kazandığında yenilenecek!💛💙",
  wheel_no_right_button1: "Fenerin Maçı Var",
  wheel_no_right_button2: "Kazandıran diğer hizmetler",
  wheel_no_right_text: "Çark çevirme hakkın Fenerbahçe kazandığında yenilenecek!💛💙 Maç gününü beklerken Fenerbahçe ile kazandıran diğer hizmetlere göz atabilirsin👀",
  wheel_success_button1: "Fenerin Maçı Var",
  wheel_success_button2: "Kazandıran diğer hizmetler",
  wheel_success_description: "Hattına yüklenince SMS ile bilgilendireceğiz. Güle güle kullan!",
  wheel_success_title: "TEBRİKLER!",
  wheel_success_title2: "KAZANDIN! 💛💙",
}
export default fb;
